var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91419 5H17.9102C19.8892 5 21.5002 6.583 21.5002 8.529V11C21.5002 11.553 21.0532 12 20.5002 12C19.9472 12 19.5002 11.553 19.5002 11V8.529C19.5002 7.687 18.7872 7 17.9102 7H5.91419L7.20719 8.293C7.59719 8.684 7.59719 9.316 7.20719 9.707C7.01219 9.902 6.75619 10 6.50019 10C6.24419 10 5.98819 9.902 5.79319 9.707L2.79319 6.707C2.40219 6.316 2.40219 5.684 2.79319 5.293L5.79319 2.293C6.18319 1.902 6.81619 1.902 7.20719 2.293C7.59719 2.684 7.59719 3.316 7.20719 3.707L5.91419 5ZM16.793 14.293C17.184 13.902 17.816 13.902 18.207 14.293L21.207 17.293C21.598 17.684 21.598 18.316 21.207 18.707L18.207 21.707C18.012 21.902 17.756 22 17.5 22C17.244 22 16.988 21.902 16.793 21.707C16.402 21.316 16.402 20.684 16.793 20.293L18.086 19H6.08999C4.10999 19 2.49999 17.417 2.49999 15.471V13C2.49999 12.447 2.94799 12 3.49999 12C4.05199 12 4.49999 12.447 4.49999 13V15.471C4.49999 16.314 5.21299 17 6.08999 17H18.086L16.793 15.707C16.402 15.316 16.402 14.684 16.793 14.293Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.7ae1daf4d5e5d573ce034a97dc2c786f.svg";
export { ForwardRef as ReactComponent };